import { JournalPriceLayout } from '@/features/journal/price';
import { marketServerProps } from '@/features/journal/market-server';

export const getServerSideProps = marketServerProps('gold');
export default JournalPriceLayout;
